exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-xs-12 {\n  width: 100%; }\n\n#fiche .container {\n  padding-top: 40px; }\n\n#fiche h4 {\n  color: #C0A986;\n  text-transform: uppercase; }\n\n#fiche .margin-top {\n  margin-top: 30px; }\n\n#fiche .del {\n  cursor: pointer; }\n\n#fiche .title,\n#fiche .btn_personalize_enable,\n#fiche .list-com {\n  margin-top: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Mustafa/Developpement/noxoe/src/components/admin/fiche/fiche.component.scss
// module id = ../../../../../src/components/admin/fiche/fiche.component.scss
// module chunks = main